/** 常量配置文件 - 和环境无关的数据 */

// 专业版才会展示的内容
export const ProfessionalOnlyMsgType = ['0x04790000', '0x047B0000'];
export const ProfessionalOnlyGpName = ['节目单','Playbill'];

export const CLIENT_ID = "opple_business_light";
/** 神策埋点数据接收地址 */
export const SENSORS_SERVER_URL = "https://sensorsdatarecv.opple.com/sa?project=ouxiangjia";

// TODO: store里面一些常量需要移动到这里来, eg: tokenMiss, rightStatusCode ...
